import { Component, Input } from '@angular/core';
import { BlockUIModule } from 'primeng/blockui';

@Component({
    standalone: true,
    imports: [BlockUIModule],
    selector: 'idb-ui-blocker',
    template: `
        <p-blockUI [blocked]="loading">
            <ng-template pTemplate="blocker">
                <div class="blocker-center">
                    <i class="pi pi-spinner pi-spin idb-loading-spin xl"></i>
                </div>
            </ng-template>
        </p-blockUI>
    `,
})
export class UIBlockerComponent {
    @Input()
    loading = false;
}